import { useParams } from 'react-router-dom';
import { AccessProvider } from '../../../../contexts/accessProvider.tsx';
import { StoreContextProvider } from '../../../../contexts/stores/store.tsx';
import { Role } from '../../../../models/enums/role.ts';
import StoreBody from './body.tsx';
import StoreHeader from './header.tsx';

const Store = () => {
    const { id } = useParams();
    return (
        <AccessProvider roles={[Role.admin, Role.superAdmin]}>
            <StoreContextProvider id={id}>
                <StoreHeader />
                <StoreBody />
            </StoreContextProvider>
        </AccessProvider>
    );
};

export default Store;
